import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-camera',
  templateUrl: './icon-camera.component.html',
  styleUrls: ['./icon-camera.component.scss']
})
export class IconCameraComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
